export function number(input) {
  return input ? input.toLocaleString('es-AR') : '';
}

export function currency(input) {
  return input ? input.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' }) : '';
}
